module.exports = __webpack_public_path__ + "static/text-3-5450e2458d5444d0ff4eecb77e0c3b92.svg";